import { getTranslationResource, languages as staticLanguages } from '@pba/static-data';

const transformLanguage = (language: (typeof staticLanguages)[number]) => ({
  code: language.code,
  translationKey: language.name.en,
});

export const languages = staticLanguages.map((language) => transformLanguage(language));

export const getTranslationLanguages = (language: keyof (typeof staticLanguages)[number]['name']) =>
  getTranslationResource(staticLanguages, language);
